import http from '@/http/aisea/axios'
const resource = "/enterprise/vessels";

export default {
  fetch(enterpriseVesselId) {
    return http.get(`${resource}/${enterpriseVesselId}/containers`)
  },
  update(enterpriseVesselId, containerId, payload) {
    return http.put(`${resource}/${enterpriseVesselId}/containers/${containerId}`, payload);
  },
  delete(enterpriseVesselId, containerId) {
    return http.delete(`${resource}/${enterpriseVesselId}/containers/${containerId}`);
  },
};